import Link from 'next/link';

import Body from 'DesignSystem3/Text/Body';
import Title from 'DesignSystem3/Text/Title';

import ProbabilityBar from './probabilityBar';
import ProbabilityBarHeader from './probabilityBarHeader';
import type { ProbabilityBarPieceVariant } from './probabilityBarPiece';
import type { StateName } from './stateProjection';
import StateProjection from './stateProjection';

interface StateProps {
    state: StateName;
    color: string;
    opacity: number;
}

interface ProbabilityBarCardProps {
    leftVariant: ProbabilityBarPieceVariant;
    rightVariant: ProbabilityBarPieceVariant;
    leftProbability: number;
    withPartyLabels: boolean;
    eventTicker: string;
    marketTicker: string;
    title: string;
    subtitle?: string;
    href: string;
    state?: StateProps;
    withMargin?: boolean;
    marketPriceIsLeft?: boolean;
    polling?: boolean;
    isIndependent?: boolean;
    isPresidency?: boolean;
    imageSize?: number;
    stackTitle?: boolean;
}

const ProbabilityBarCard = ({
    leftVariant,
    rightVariant,
    leftProbability,
    withPartyLabels,
    eventTicker,
    marketTicker,
    title,
    subtitle,
    href,
    state,
    withMargin = true,
    marketPriceIsLeft = false,
    polling = true,
    isIndependent = false,
    isPresidency = false,
    imageSize = 32,
    stackTitle = false,
}: ProbabilityBarCardProps) => {
    return (
        <div className={`flex flex-col gap-1.5 ${withMargin ? 'mt-4 mb-4' : ''}`}>
            <Link href={href} prefetch={false}>
                <div className="flex cursor-pointer w-full text-text-x10 group">
                    {!!state && (
                        <div
                            className="flex mr-1.5 group-hover:!opacity-100 h-6 justify-center items-center"
                            style={{ opacity: state.opacity }}
                        >
                            <StateProjection state={state.state} color={state.color} opacity={1} />
                        </div>
                    )}
                    <div
                        className={`flex ${
                            withMargin || stackTitle ? 'flex-col' : 'flex-1 items-center flex-row justify-between'
                        }`}
                    >
                        <div className="flex group-hover:underline">
                            <Title.x10>{title}</Title.x10>
                        </div>
                        {!!subtitle && (
                            <div className="flex text-text-x20">
                                <Body.x20>{subtitle}</Body.x20>
                            </div>
                        )}
                    </div>
                </div>
            </Link>
            {withPartyLabels && (
                <ProbabilityBarHeader isIndependent={isIndependent} isPresidency={isPresidency} imageSize={imageSize} />
            )}
            <ProbabilityBar
                leftVariant={leftVariant}
                rightVariant={rightVariant}
                initialLeftProbability={leftProbability}
                withExtraTopPadding={withPartyLabels}
                eventTicker={eventTicker}
                marketTicker={marketTicker}
                marketPriceIsLeft={marketPriceIsLeft}
                polling={polling}
            />
        </div>
    );
};

export default ProbabilityBarCard;
